
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 0h40v40H0V0z","fill":"#4F4F51"}}),_c('path',{attrs:{"d":"M35.575 7.608l-4.496 7.238c-.51.804-.424 1.439-.17 2.074l6.83 17.397H9.488c-2.546 0-4.497-2.032-4.497-4.445L4.949 6.677c.085-3.006 4.454-3.048 4.54 0V28.39c0 .677.593 1.481 1.399 1.439h20.7l-5.345-12.571c-.127-.466-.254-.974-.254-1.44 0-.55.254-1.396.594-2.074l4.92-8.084c.382-.72 1.103-1.228 1.951-1.27 1.23-.043 2.29.804 2.333 2.074-.042.296-.085.889-.212 1.143z","fill":"#fff"}}),_c('path',{attrs:{"d":"M19.993 22.212V6.677c0-3.047 4.454-3.047 4.497 0v15.704c0 3.598-2.673 5.968-5.981 5.968-3.309 0-5.981-2.455-5.981-5.968V6.677c0-3.047 4.496-3.047 4.496 0v15.535c-.042 2.116 2.97 2.243 2.97 0z","fill":"#fff"}})])
          )
        }
      }
    